export const TRANSITION_TIME = 1500;
export const INTERVAL = 4000;
